import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function searchConfigSql(qryConds) {
  return Vue.http.get(api + 'cfg_sql/list',{params:qryConds})
}

export function saveConfigSql(cfgSql){
  return Vue.http.post(api + 'cfg_sql/save', cfgSql)
}